(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Mega menu v2: child hover panel switching
  function initMegaMenuV2(root) {
    root.querySelectorAll('details.mega-menu-v2').forEach(function(details) {
      var inner = details.querySelector('.mega-menu-v2__inner');
      if (!inner) return;
      var childItems = inner.querySelectorAll('.mega-menu-v2__child-item[data-mega-index]');
      var panels = inner.querySelectorAll('.mega-menu-v2__panel[data-mega-panel]');

      var panelsContainer = inner.querySelector('.mega-menu-v2__panels');

      function activatePanel(idx, animate) {
        childItems.forEach(function(item) {
          item.classList.toggle('mega-menu-v2__child-item--active', item.dataset.megaIndex === String(idx));
        });
        panels.forEach(function(panel) {
          var isActive = panel.dataset.megaPanel === String(idx);
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
        });
        if (panelsContainer) {
          var activePanel = inner.querySelector('.mega-menu-v2__panel.is-active');
          var targetHeight = activePanel ? activePanel.scrollHeight : 0;
          if (!animate) {
            panelsContainer.style.transition = 'none';
            panelsContainer.style.height = targetHeight + 'px';
            requestAnimationFrame(function() { panelsContainer.style.transition = ''; });
          } else {
            panelsContainer.style.height = targetHeight + 'px';
          }
        }
      }

      // Activate first panel immediately when details opens (no animation)
      details.addEventListener('toggle', function() {
        if (details.open && panels.length > 0) {
          activatePanel(panels[0].dataset.megaPanel, false);
          
          document.body.classList.add('mega-menu-open');
        } else if (!details.open && panelsContainer) {
          panelsContainer.style.transition = 'none';
          panelsContainer.style.height = '0';
          requestAnimationFrame(function() { panelsContainer.style.transition = ''; });

          document.body.classList.remove('mega-menu-open');
        }
      });

      // Switch panel on child hover (with animation)
      childItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          activatePanel(item.dataset.megaIndex, true);
        });
      });
    });

    // Prevent details toggle when clicking the parent link text
    root.querySelectorAll('.mega-menu__parent-link').forEach(function(a) {
      a.addEventListener('click', function(e) { e.stopPropagation(); });
    });
  }

  initMegaMenuV2(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-text"] && !Shopify.designMode) return;
  try {
    
  let seoTextInterval = null;
  
  const processSeoText = () => {
    try {
        const $is_seo_text = $('.is-seo-text');
        $is_seo_text.find('#dots').remove();
        $is_seo_text.find('.readmorelink').remove();
      
        const $html_seo = $is_seo_text.html();
        const $seo_text = $is_seo_text.text().trim();
      
        let $text_cutoff;
        let $suffix_seo_text = '';
    
        $text_cutoff = $seo_text.split(' ');
    
        if($text_cutoff.length > 100) {
          $text_cutoff = $text_cutoff.slice(0, 100);
          $suffix_seo_text = ' <a href="javascript:void(0)" class="js-seo-text">read more</a>';
        }
    
        $text_cutoff = $text_cutoff.join(' ').replace(/\s+/g,' ');
    
        // replace seo_text
        $is_seo_text.html( $text_cutoff + $suffix_seo_text);
    
        $('.is-seo-text').on('click', '.js-seo-text', function(e) {
            $is_seo_text.html($html_seo);
        });
    } catch(err) {
        console.log(err.message);
    }
  };

  const initSeoText = () => {
    seoTextInterval = setInterval(() => {
      if (typeof(window.jQuery) !== 'undefinede') {
        clearInterval(seoTextInterval);
        processSeoText();
      }
    }, 500);
  };

  initSeoText();

  } catch(e) { console.error(e); }
})();
})();
